/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { formatMoney as formatMoneySarsa } from 'sarsaparilla';

export const formatMoney = (val) => {
    return formatMoneySarsa(val);
};

export function getDiscountPriceText(ticketCost, quantityDiscount) {
    let quantityTicketPriceText;

    if (ticketCost && ticketCost > 0 && quantityDiscount && quantityDiscount !== 0) {
        const quantityTicketPrice = ticketCost - quantityDiscount;
        quantityTicketPriceText = formatMoney(quantityTicketPrice);
    }

    return quantityTicketPriceText;
}

export function getFeeText(fee, comment = '', perTransaction = false) {
    let separator = ' ';
    if (comment.length > 0 && comment[0] === ',') {
        separator = '';
    }
    if (fee.units === 'PERCENT') {
        const resultComment = comment ? `${separator}${comment}` : '';
        if (fee.unit_price === 100) {
            return `No refunds${resultComment}`;
        }

        return `${fee.unit_price} percent of ticket cost${comment}`;
    }

    const resultComment = comment ? `${separator}${comment}` : '';
    let per = ` per ticket${resultComment}`;
    if (fee.per === 'TRANSACTION' || perTransaction) {
        per = ` per transaction${resultComment}`;
    }

    return `${formatMoney(fee.unit_price)}${per}`;
}

export function getQuantityDiscountThresholdText(quantityDiscountThreshold) {
    if (quantityDiscountThreshold && quantityDiscountThreshold > 0) {
        return `* Price per ticket when purchasing ${quantityDiscountThreshold}+ tickets.`;
    }

    return null;
}
